import i18n from "i18next";
import { initReactI18next } from "react-i18next";
i18n.use(initReactI18next).init({
  resources: {
    "pt-BR": {
      translations: {
        language: "Idioma",
        spanish: "Espanhol",
        portuguese: "Português",
        options: {
          contact: "Contato",
          sales: "Vendas",
          travelers: "Viajantes",
          claims: "Reclamações",
          needAssistance: "Preciso de ajuda",
          myVoucher: "Minha Apólice",
          refunds: "Reembolso",
          faqs: "Perguntas frequentes",
          ccgg: "Condições gerais",
          utils: "Úteis",
          affiliates: "Afiliados",
          enterprises: "Empresas",
          blog: "Blog",
          policyPrivacy: "Política de privacidade",
          policyCookies: "Política de cookies",
          unsubscribeButton: "Cancelar inscrição",
        },
        copyright:
          "Copyright © {{year}} ASSIST 365. Todos os direitos reservados.",
        dropline:
          "Assist 365 é a cobertura de seguro viagem preferida por milhares de viajantes da Europa, América Latina, Oceania, Ásia e América do Norte.",
        legal:
          "Os serviços da Assist 365 possuem limitações exclusivas de acordo com o tipo de produto adquirido. Aplicam-se as limitações e exclusões de uso habitual e/ou legal no país em que o produto Assist 365 é emitido. A partir dos 75 anos, é aplicado um aumento de 50% sobre as tarifas. As doenças preexistentes possuem exclusões e limitações. Os serviços e produtos são regidos por condições gerais, detalhadas no momento da compra de cada produto Assist 365. Recomendamos que leia atentamente essas condições, que estão disponíveis no site ou podem ser solicitadas por e-mail: falecom@assist-365.com.",
        follow: "Siga-nos nas redes sociais",
        countries: {
          ar: "Argentina",
          cl: "Chile",
          br: "Brasil",
          mx: "México",
          sp: "España",
          us: "Estados Unidos",
          co: "Colombia",
          au: "Australia",
        },
        modalContact: {
          sales: "Vendas",
          whatsapp: "Whatsapp",
          phoneSupport: "Emergências",
          emergencies: "Preciso de ajuda",
          needHelp: "Necesito asistencia",
        },
        modalNeedHelp: {
          title: "Insira seu documento",
          dropline:
            "Insira o documento de qualquer um dos passageiros incluídos na cobertura, utilizando o mesmo informado na compra.",
          docTypeLabel: "Tipo de documento",
          docNumberLabel: "Número de documento",
          docNumberPlaceholder: "Insira o número sem pontos ou hífen",
          btnLabel: "Continuar",
          supportData: {
            title1: "Contatos de emergência",
            dropline1:
              "Diante de um imprevisto, entre em contato de qualquer país, a qualquer hora.",
            title2: "Whatsapp",
            title3: "Atendimento telefônico",
            title4: "E-mail",
          },
        },
      },
    },
    es: {
      translations: {
        language: "Idioma",
        spanish: "Español",
        portuguese: "Portugues",
        options: {
          contact: "Contacto",
          sales: "Ventas",
          phoneSupport: "Atención telefónica",
          claims: "Reclamos",
          needAssistance: "Necesito asistencia",
          travelers: "Viajeros",
          myVoucher: "Mi voucher",
          refunds: "Reintegros",
          faqs: "Preguntas frecuentes",
          ccgg: "Condiciones generales",
          utils: "Útiles",
          affiliates: "Afiliados",
          enterprises: "Empresas",
          blog: "Blog",
          policyPrivacy: "Política de privacidad",
          policyCookies: "Política de cookies",
          regretButton: "Botón de arrepentimiento",
          unsubscribeService: "Botón de baja",
          unsubscribeButton: "Cancelar suscripción",
        },
        copyright:
          "Copyright © {{year}} ASSIST 365. Todos los derechos reservados.",
        dropline:
          "Assist 365 es la cobertura de asistencia al viajero preferida por miles de viajeros de Europa, Latinoamérica, Oceanía, Asia y Norteamérica.",
        legal:
          "LOS SERVICIOS ASSIST 365 TIENEN LIMITACIONES EXCLUSIVAS SEGÚN EL TIPO DE PRODUCTO ADQUIRIDO. APLICAN LAS LIMITACIONES Y EXCLUSIONES DE USO HABITUAL Y/O LEGAL EN EL PAÍS EN QUE SE EMITA EL PRODUCTO ASSIST 365. A PARTIR DE LOS 75 AÑOS INCLUSIVE SE APLICA UN INCREMENTO DEL 50% SOBRE LAS TARIFAS. EL LÍMITE DE EDAD PARA LAS COBERTURAS OFRECIDAS ES DE HASTA 85 AÑOS, Y LOS SERVICIOS OFRECEN UNA COBERTURA DE ALCANCE MUNDIAL, A EXCEPCIÓN DEL PAÍS DE RESIDENCIA PERMANENTE DEL BENEFICIARIO. LOS SERVICIOS Y PRODUCTOS SE RIGEN POR CONDICIONES GENERALES QUE SE INFORMAN CON LA COMPRA DE CADA PRODUCTO ASSIST 365 Y SE HALLAN A SU DISPOSICIÓN INGRESANDO EN EL PORTAL WEB, PUEDEN SER SOLICITADAS EN FORMA TELEFÓNICA O POR E-MAIL. LAS ENFERMEDADES PREEXISTENTES TIENEN EXCLUSIONES Y LIMITACIONES. ASSIST 365 NO ES UNA EMPRESA DE SEGUROS, SINO QUE ACTÚA EN CALIDAD DE TOMADORA EN BENEFICIO DE SUS CLIENTES.",
        follow: "Síguenos en redes",
        countries: {
          ar: "Argentina",
          cl: "Chile",
          br: "Brasil",
          mx: "México",
          es: "España",
          us: "Estados Unidos",
          co: "Colombia",
          au: "Australia",
        },
        modalContact: {
          sales: "Ventas",
          whatsapp: "Whatsapp",
          emergencies: "Emergencias",
          needHelp: "Necesito asistencia",
          phoneSupport: "Atención telefónica",
          phoneTime: "De Lunes a Viernes de 09 a 21hs",
        },
        modalNeedHelp: {
          title: "Ingresá tu documento",
          dropline:
            "Podés ingresar el documento de cualquiera de los pasajeros incluidos en la cobertura",
          docTypeLabel: "Tipo de documento",
          docNumberLabel: "Número de documento",
          docNumberPlaceholder: "Ingresá el número",
          btnLabel: "Continuar",
          supportData: {
            title1: "Contactos de emergencia",
            dropline1:
              "Ante un imprevisto comunicate desde cualquier país en cualquier horario",
            title2: "Whatsapp",
            dropline2: "+1 305 434 4970",
            title3: "Atención telefónica",
            dropline3: "+34 91 946 4073",
            title4: "Correo electrónico",
            dropline4: "operaciones.365@worldmedicalcare.com",
          },
        },
      },
    },
    "es-AR": {
      translations: {
        language: "Idioma",
        spanish: "Español",
        portuguese: "Portugues",
        options: {
          contact: "Contacto",
          sales: "Ventas",
          phoneSupport: "Atención telefónica",
          claims: "Reclamos",
          needAssistance: "Necesito asistencia",
          travelers: "Viajeros",
          myVoucher: "Mi voucher",
          refunds: "Reintegros",
          faqs: "Preguntas frecuentes",
          ccgg: "Condiciones generales",
          utils: "Útiles",
          affiliates: "Afiliados",
          enterprises: "Empresas",
          blog: "Blog",
          policyPrivacy: "Política de privacidad",
          policyCookies: "Política de cookies",
          regretButton: "Botón de arrepentimiento",
          unsubscribeService: "Botón de baja",
          unsubscribeButton: "Cancelar suscripción",
        },
        copyright:
          "Copyright © {{year}} ASSIST 365. Todos los derechos reservados.",
        dropline:
          "Assist 365 es la cobertura de asistencia al viajero preferida por miles de viajeros de Europa, Latinoamérica, Oceanía, Asia y Norteamérica.",
        legal:
          "LOS SERVICIOS ASSIST 365 TIENEN LIMITACIONES EXCLUSIVAS SEGÚN EL TIPO DE PRODUCTO ADQUIRIDO. APLICAN LAS LIMITACIONES Y EXCLUSIONES DE USO HABITUAL Y/O LEGAL EN EL PAÍS EN QUE SE EMITA EL PRODUCTO ASSIST 365. A PARTIR DE LOS 75 AÑOS INCLUSIVE SE APLICA UN INCREMENTO DEL 50% SOBRE LAS TARIFAS. EL LÍMITE DE EDAD PARA LAS COBERTURAS OFRECIDAS ES DE HASTA 85 AÑOS, Y LOS SERVICIOS OFRECEN UNA COBERTURA DE ALCANCE MUNDIAL, A EXCEPCIÓN DEL PAÍS DE RESIDENCIA PERMANENTE DEL BENEFICIARIO. LOS SERVICIOS Y PRODUCTOS SE RIGEN POR CONDICIONES GENERALES QUE SE INFORMAN CON LA COMPRA DE CADA PRODUCTO ASSIST 365 Y SE HALLAN A SU DISPOSICIÓN INGRESANDO EN EL PORTAL WEB, PUEDEN SER SOLICITADAS EN FORMA TELEFÓNICA O POR E-MAIL. LAS ENFERMEDADES PREEXISTENTES TIENEN EXCLUSIONES Y LIMITACIONES. ASSIST 365 NO ES UNA EMPRESA DE SEGUROS, SINO QUE ACTÚA EN CALIDAD DE TOMADORA EN BENEFICIO DE SUS CLIENTES.",
        follow: "Seguinos en redes",
        countries: {
          ar: "Argentina",
          cl: "Chile",
          br: "Brasil",
          mx: "México",
          sp: "España",
          us: "Estados Unidos",
          co: "Colombia",
          au: "Australia",
        },
        modalContact: {
          sales: "Ventas",
          whatsapp: "Whatsapp",
          emergencies: "Emergencias",
          needHelp: "Necesito asistencia",
          phoneSupport: "Atención telefónica",
          phoneTime: "De Lunes a Viernes de 09 a 21hs",
        },
        modalNeedHelp: {
          title: "Ingresá tu documento",
          dropline:
            "Podés ingresar el documento de cualquiera de los pasajeros incluidos en la cobertura",
          docTypeLabel: "Tipo de documento",
          docNumberLabel: "Número de documento",
          docNumberPlaceholder: "Ingresá el número",
          btnLabel: "Continuar",
          supportData: {
            title: "Contactos de emergencia",
            dropline:
              "Ante un imprevisto comunicate desde cualquier país en cualquier horario",
            whatsapp: "Whatsapp",
            dropline2: "+1 305 434 4970",
            phone: "Atención telefónica",
            dropline3: "+34 91 946 4073",
            email: "Correo electrónico",
            dropline4: "operaciones.365@worldmedicalcare.com",
          },
        },
      },
    },
  },
  lng: "es-AR",
  fallbackLng: "es",
  ns: ["translations"],
  defaultNS: "translations",
});
export default i18n;
